import { render, staticRenderFns } from "./News20251226.vue?vue&type=template&id=bf9b2d34&scoped=true&"
import script from "./News20251226.vue?vue&type=script&lang=js&"
export * from "./News20251226.vue?vue&type=script&lang=js&"
import style0 from "./News20251226.vue?vue&type=style&index=0&id=bf9b2d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9b2d34",
  null
  
)

export default component.exports